__webpack_require__.p = "/bizx-smart/wijea-wikrama/";